export default "__VITE_ASSET__j50C3Vgx__"